interface EnhancementsSummaryFilterState {
  selection: string[] | undefined
  selectedEmployeeIds: number[]
}

const enhancementsSummaryFilterState = {
  selection: [],
  selectedEmployeeIds: []
}

export interface EnhancementsSummaryState {
  filterStates: EnhancementsSummaryFilterState
}

export const enhancementsSummaryInitialState: EnhancementsSummaryState = {
  filterStates: enhancementsSummaryFilterState,
}

const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER'
const SET_SELECTED_EMPLOYEES = 'SET_SELECTED_EMPLOYEES'
const RESET_ENHANCEMENTS_FILTERS = 'RESET_ENHANCEMENTS_FILTERS'

export interface SetSelectedFilterAction {
  type: typeof SET_SELECTED_FILTER
  payload: string[] | undefined
}

export interface SetSelectedEmployeesAction {
  type: typeof SET_SELECTED_EMPLOYEES
  payload: number[]
}

interface ResetFiltersAction {
  type: typeof RESET_ENHANCEMENTS_FILTERS
}

type enhancementsSummaryDispatchtypes = SetSelectedFilterAction | SetSelectedEmployeesAction | ResetFiltersAction 

// Actions
export const setSelectedFilter = (
  selectedFilter: string[] | undefined
): SetSelectedFilterAction => ({
  type: SET_SELECTED_FILTER,
  payload: selectedFilter,
})

export const setSelectedEmployees = (selectedEmployees: number[]): SetSelectedEmployeesAction => ({
  type: SET_SELECTED_EMPLOYEES,
  payload: selectedEmployees,
})

export const resetFilters = (): ResetFiltersAction => ({
  type: RESET_ENHANCEMENTS_FILTERS
})

// Reducer
export const enhancementsSummaryReducer = (
  state: EnhancementsSummaryState = enhancementsSummaryInitialState,
  action: enhancementsSummaryDispatchtypes
): EnhancementsSummaryState => {
  switch (action.type) {
    case SET_SELECTED_FILTER:
      return { ...state, filterStates: { ...state.filterStates, selection: action.payload } }
    case SET_SELECTED_EMPLOYEES: 
      return { ...state, filterStates: { ...state.filterStates, selectedEmployeeIds: action.payload } }
    case RESET_ENHANCEMENTS_FILTERS:
      return { ...state, filterStates: enhancementsSummaryFilterState }
    default:
      return state
  }
}
